/**
 * Identifies the procedure followed when washing material
 */
export enum WashingProcedure {
  /**
   * Material is washed with plain water, typically for non-cohesive soils.
   * This is referred to as method A in ASTM C117, ASTM D1140 and AASHTO T 11.
   */
  WashWithPlainWater = 'WashWithPlainWater',
  /**
   * Material is washed using a wetting agent or dispersant to separate cohesive soils.
   * This is referred to as method B in ASTM C117, ASTM D1140 and AASHTO T 11.
   */
  WashWithWaterAndAgent = 'WashWithWaterAndAgent',
}

/**
 * Identifies the type of apparatus used to assist in the dispersion of soil.
 */
export enum DispersionApparatusType {
  /**
   * No apparatus was used to assist with the dispersion of soil.
   */
  None = 'None',
  /**
   * An apparatus using ultrasonic vibration was used to assist with the dispersion of soil.
   */
  Ultrasonic = 'Ultrasonic',
  /**
   * An apparatus which shakes the sample was used to assist with the dispersion of soil.
   */
  Shaken = 'Shaken',
}
export enum MaterialDryMassObtainedBy {
  Measured = 'Measured',
  Imported = 'Imported',
}
